import { Gift, X } from "lucide-react";

interface GiftCartItemProps {
  name: string;
  image: string;
  variant?: string;
  originalPrice?: number;
  currency?: string;
  onRemove?: () => void;
}

export const GiftCartItem = ({
  name,
  image,
  variant,
  originalPrice,
  currency = "€",
  onRemove,
}: GiftCartItemProps) => {
  return (
    <div className="flex gap-3 p-3 rounded-xl border border-primary/30 bg-primary/5">
      <div className="relative w-20 h-20 rounded-lg overflow-hidden bg-secondary flex-shrink-0">
        <img src={image} alt={name} className="w-full h-full object-cover" />
        <span className="absolute bottom-0 inset-x-0 bg-primary text-primary-foreground text-[10px] font-bold text-center py-0.5">
          ZADARMO
        </span>
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-start gap-2 mb-1">
          <div className="min-w-0">
            <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-primary mb-1">
              <Gift className="w-3.5 h-3.5" />
              Darček k nákupu
            </span>
            <h4 className="text-sm font-medium text-foreground line-clamp-2">{name}</h4>
          </div>
          <div className="text-right whitespace-nowrap">
            <span className="text-sm font-semibold text-primary">Zadarmo</span>
            {originalPrice ? (
              <div className="text-xs text-muted-foreground line-through">
                {originalPrice.toFixed(2).replace(".", ",")} {currency}
              </div>
            ) : null}
          </div>
        </div>

        {variant && <p className="text-xs text-primary mb-2">{variant}</p>}

        <div className="flex items-center gap-3">
          <span className="text-xs text-muted-foreground">Množstvo: 1</span>
          {onRemove && (
            <button
              onClick={onRemove}
              className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-destructive transition-colors underline underline-offset-2"
            >
              <X className="w-3 h-3" />
              Odstrániť darček
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
